import { Box, Tooltip } from '@mui/material';

interface TimelineAvailabilityBlockProps {
  leftPercent: number;
  widthPercent: number;
  variant?: 'available' | 'override' | 'closed';
  tooltip?: React.ReactNode;
}

const VARIANT_STYLES = {
  available: {
    bgcolor: '#20b020',
    border: 'none',
    borderStyle: undefined as string | undefined,
    opacity: 0.85,
  },
  override: {
    bgcolor: '#f4b020',
    border: '2px dashed #e68a00',
    borderStyle: 'dashed' as const,
    opacity: 0.7,
  },
  closed: {
    bgcolor: '#e1e3e5',
    border: 'none',
    borderStyle: undefined as string | undefined,
    opacity: 0.5,
  },
};

const TimelineAvailabilityBlock: React.FC<TimelineAvailabilityBlockProps> = ({
  leftPercent,
  widthPercent,
  variant = 'available',
  tooltip,
}) => {
  const style = VARIANT_STYLES[variant];

  const block = (
    <Box
      sx={{
        position: 'absolute',
        left: `${leftPercent}%`,
        width: `${widthPercent}%`,
        top: 4,
        bottom: 4,
        bgcolor: style.bgcolor,
        border: style.border,
        borderRadius: '4px',
        opacity: style.opacity,
        transition: 'opacity 150ms ease',
        '&:hover': { opacity: 1 },
      }}
    />
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="top" arrow>
        {block}
      </Tooltip>
    );
  }

  return block;
};

export default TimelineAvailabilityBlock;
